<script setup>
  const { article } = defineProps({
    article: { required: true, type: Object }
  })
</script>

<template>
  <NuxtLink class="flex flex-col shadow duration-300 hover:shadow-md" target="_blank" :to="`https://media.profilpublic.fr/blog/${article.slug}`">
    <div
      class="w-full flex-none bg-zinc-300 bg-cover bg-center pt-[50.90909%]"
      :style="{
        backgroundImage: article.image?.url ? `url('${useStrapiMedia(article.image.url)}')` : undefined
      }"
    />
    <div class="flex-1 bg-white px-4 py-2">
      <div class="line-clamp-2" v-html="article.title" />
    </div>
  </NuxtLink>
</template>
